/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistQuantitativeQuestionOperationalScopeDTO} from './ChecklistQuantitativeQuestionOperationalScopeDTO';

/**
 * The ChecklistQuantitativeQuestionDTO model module.
 * @module model/ChecklistQuantitativeQuestionDTO
 * @version v0
 */
export class ChecklistQuantitativeQuestionDTO {
  /**
   * Constructs a new <code>ChecklistQuantitativeQuestionDTO</code>.
   * @alias module:model/ChecklistQuantitativeQuestionDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistQuantitativeQuestionDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistQuantitativeQuestionDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistQuantitativeQuestionDTO} The populated <code>ChecklistQuantitativeQuestionDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistQuantitativeQuestionDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('question'))
        obj.question = ApiClient.convertToType(data['question'], 'String');
      if (data.hasOwnProperty('checklistQuantitativeQuestionOperationalScopes'))
        obj.checklistQuantitativeQuestionOperationalScopes = ApiClient.convertToType(data['checklistQuantitativeQuestionOperationalScopes'], [ChecklistQuantitativeQuestionOperationalScopeDTO]);
      if (data.hasOwnProperty('note'))
        obj.note = ApiClient.convertToType(data['note'], 'String');
      if (data.hasOwnProperty('displayId'))
        obj.displayId = ApiClient.convertToType(data['displayId'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistQuantitativeQuestionDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
ChecklistQuantitativeQuestionDTO.prototype.position = undefined;

/**
 * @member {String} question
 */
ChecklistQuantitativeQuestionDTO.prototype.question = undefined;

/**
 * @member {Array.<module:model/ChecklistQuantitativeQuestionOperationalScopeDTO>} checklistQuantitativeQuestionOperationalScopes
 */
ChecklistQuantitativeQuestionDTO.prototype.checklistQuantitativeQuestionOperationalScopes = undefined;

/**
 * @member {Number} displayId
 */
ChecklistQuantitativeQuestionDTO.prototype.displayId = undefined;

/**
 * @member {String} note
 */
ChecklistQuantitativeQuestionDTO.prototype.note = undefined;

